import VmpPcPlayerLiveYun from './src/main.vue';

VmpPcPlayerLiveYun.install = function (Vue) {
  Vue.component(VmpPcPlayerLiveYun.name, VmpPcPlayerLiveYun);
};
export default VmpPcPlayerLiveYun;
